export { default } from './NProgressBar';
